import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import CoreLayoutRoute from './layouts/CoreLayoutRoute'
import V6PlainRoute from './legacy/V6PlainRoute'
import GetComponentRoute from './legacy/GetComponentRoute'
import createStudiesRoutes from '../routes/Studies'
import ActivateUserRoute from '../routes/ActivateUser'
import LoginRoute from '../routes/Login'
import ProfilePageRoute from '../routes/ProfilePage'
import ResetPasswordRoute from '../routes/ResetPassword'
import UnauthorizedRoute from '../routes/Unauthorized'

export default function AppRoutes({ store }) {
  const activateUser = ActivateUserRoute(store)
  const login = LoginRoute(store)
  const profile = ProfilePageRoute(store)
  const resetPassword = ResetPasswordRoute(store)
  const unauthorized = UnauthorizedRoute(store)

  return (
    <Routes>
      <Route path="/" element={<CoreLayoutRoute store={store} />}>
        <Route index element={<Navigate to="/studies" replace />} />
        <Route
          path="users/activate/*"
          element={<GetComponentRoute getComponent={activateUser.getComponent} />}
        />
        <Route path="login/*" element={<GetComponentRoute getComponent={login.getComponent} />} />
        <Route path="users/me/*" element={<GetComponentRoute getComponent={profile.getComponent} />} />
        <Route
          path="users/reset/*"
          element={<GetComponentRoute getComponent={resetPassword.getComponent} />}
        />
        <Route
          path="studies/*"
          element={<V6PlainRoute factory={createStudiesRoutes} store={store} />}
        />
        <Route
          path="unauthorized/*"
          element={<GetComponentRoute getComponent={unauthorized.getComponent} />}
        />
      </Route>
    </Routes>
  )
}
